<template lang="html">
<div class="subpage addrule_edit">
    <el-form ref="ruleForm" :model="params" :rules="rules" :show-message="true" label-position="right" label-width="120px">
        <!-- 所属栏目 -->
        <el-form-item label="所属机构" prop="orgIds">
            <el-cascader ref="cascaderOrg" :options="orgTree" :show-all-levels="true" :props="{ value: 'id', label: 'name', children: 'getCompanyPostModules' ,checkStrictly: true}" :value="orgIds" @change="orgSelectChange" clearable placeholder="请选择机构"></el-cascader>
        </el-form-item>
        <!-- 标题 -->
        <el-form-item label="角色名称" prop="name">
            <el-input size="medium" v-model="params.name" placeholder="请输入角色名称"></el-input>
        </el-form-item>
        <!--  缩略图 -->
        <el-form-item label="内容权限" prop="checkedSeeRule">
            <el-checkbox v-model="params.seeRule" :true-label="2" :false-label="1" >只允许查看自己发布的文档</el-checkbox>
        </el-form-item>
        <!-- 摘要 -->
        <el-form-item label="内容审核" prop="checkedCheckRule">
            <el-checkbox v-model="params.checkRule"  :true-label="2" :false-label="1">发布内容自动通过审核</el-checkbox>
        </el-form-item>
        <!-- 内容 -->
        <el-form-item label="功能权限" prop="menuIds">
            <el-cascader ref="cascaderMenu" :options="menuTree" collapse-tags :props="{ value: 'id', label: 'name', children: 'getMenuModules' ,multiple: true,checkStrictly: true}" :value="menuIds" @change="menuSelectChange" clearable placeholder="请选择菜单"></el-cascader>
        </el-form-item>
        <el-form-item label="栏目权限" prop="columnIds">
            <el-cascader ref="cascaderColumn" :options="columnTree" collapse-tags :show-all-levels="true" :props="{ value: 'id', label: 'name', children: 'dtos' ,multiple: true}" :value="columnIds" @change="columnSelectChange" clearable placeholder="请选择栏目"></el-cascader>
        </el-form-item>
    </el-form>
</div>
</template>

<script>
// import { userSeek } from "@/api/account";
import {
    getColumnTree
} from '@/api/jingshi';
import {
    getOrganizationTree,
    editManagePostDTO,
} from '@/api/pgMent/roleMent';
import {
    getMenu,
} from '@/api/pgMent/modelSet';
export default {
    props: ['article'],
    data() {
        return {
            params: {
                id: '',
                name: '',
                organizationId: '',
                organizationIds: '',
                organizationName: '', // 内容
                seeRule: 1, // 无权限1 有权限2
                checkRule: 1, // 无权限1 有权限2
                columnIds: [],
                menuIds: [],
            },
            selectData: {},
            columnTree: [],
            menuTree: [],
            orgTree: [],
            columnIds: [],
            orgIds: [],
            menuIds: [],
            rules: {
                // orgIds: [{type: 'object', required: true, message: '请至少选择一个机构', trigger: 'change'}],
                name: [{
                    required: true,
                    message: '角色名称不能为空',
                    trigger: 'blur'
                }],
                // checkedSeeRule: [{
                //     required: true,
                //     message: '内容查看权限不能为空',
                //     trigger: 'blur'
                // }],
                // checkedCheckRule: [{
                //     required: true,
                //     message: '内容审核权限不能为空',
                //     trigger: 'blur'
                // }],
                // columnIds: [{
                //     required: true,
                //     message: '栏目权限不能为空',
                //     // validator: validatePass2,
                //     trigger: 'blur'
                // }],
                // menuIds: [{
                //     required: true,
                //     message: '功能权限不能为空',
                //     // validator: validatePass2,
                //     trigger: 'blur'
                // }],

            }
        }
    },
    watch: {
        article: function (e) {
            if (e) {
                this.params = e;

                var arr = this.params.pids.split(",").reverse();
                console.log(this.params, arr);
                this.ids = arr;
            }
        }
    },
    methods: {

        columnSelectChange: function (e) {
            this.columnIds = e;
            this.params.columnIds = [];
            // var checkLabels = this.$refs['cascaderColumn'].getCheckedNodes();

            for (var i = 0; i < e.length; i++) {
                console.log(e[i]);
                var strId = e[i].join(',');
                this.params.columnIds.push(strId);
            }
            console.log(this.params);
        },
        menuSelectChange: function (e) {
            this.menuIds = e;
            this.params.menuIds = [];
            var checkLabels = this.$refs['cascaderMenu'].getCheckedNodes();

            for (var i = 0; i < checkLabels.length; i++) {
                console.log(checkLabels[i]);
                this.params.menuIds.push(checkLabels[i].data.pIds);
            }
            console.log(this.params);
        },
        orgSelectChange: function (e) {
            this.orgIds = e;
         
            var checkLabels = this.$refs['cascaderOrg'].getCheckedNodes();
            this.params.organizationId=checkLabels[0].value;
            this.params.organizationName=checkLabels[0].label;
            this.params.organizationIds=checkLabels[0].data.pIds;
            // for(var i=0;i<checkLabels.length;i++){
            //     console.log(checkLabels[i]);
            //     var strId=checkLabels[i].data.pids.join(',');
            //     this.params.orgIds.push(strId);
            // }
            console.log(this.orgIds, this.params,checkLabels);
        },
        /**
         * data 来源tree
         * id 需要匹配的id
         * descData 匹配到的结果
         * childflag 属性子属性组的key
         */
        getTreeDataById(data, id, descData, childflag) {
            for (var i = 0; i < data.length; i++) {
                if (data[i].id === id) {
                    descData = data[i];
                    break;
                } else {
                    if (data[i][childflag]) {
                        this.getTreeDataById(data[i][childflag], id, descData, childflag);
                    }
                }
            }
            return;
        },
        handleMenuTree(data, childflag) {
            for (var i = 0; i < data.length; i++) {
                if(data[i]['description']){
                    data[i]['name'] = data[i]['name']+'['+data[i]['description']+']';
                }
                if (data[i][childflag]&&data[i][childflag].length >0) {
                    this.handleMenuTree(data[i][childflag], childflag);
                } 
            }
            return data;
        },
        handleTree(data, childflag) {
            for (var i = 0; i < data.length; i++) {
                
                if (data[i][childflag].length == 0) {
                    delete data[i][childflag];
                } else {
                    this.handleTree(data[i][childflag], childflag);
                }
            }
            return data;
        },
        handleTreeNodeArray(arrData,descArr){
          for(var i=0;i<arrData.length;i++){
            var arr=arrData[i].split(',');
            descArr.push(arr);
          }
          return descArr;
        },
        getMenuTree() {
            var vues = this;
            getMenu().then(res => {
                console.log(res);
                vues.menuTree = vues.handleTree(res.getMenuTreeModules, 'getMenuModules');
                vues.menuTree  = vues.handleMenuTree(vues.menuTree ,'getMenuModules');
                
            })
        },
        getOrgTree() {
            var vues = this;
            getOrganizationTree().then(res => {
                vues.orgTree = vues.handleTree(res.getCompanyPostTreeModules, 'getCompanyPostModules');
            })
        },
        getColumnTree() {
            var vues = this;
            getColumnTree().then(res => {
                vues.columnTree = vues.handleTree(res.cmsColumnLists, 'dtos');
            })
        },
        editManagePostDTO() {
            var vues = this;
            editManagePostDTO({
                id: this.params.id,
            }).then(res => {
                console.log(res);
                vues.params = res.manageEditRole;
                vues.menuIds = vues.handleTreeNodeArray(vues.params.menuIds,[]);
                vues.columnIds = vues.handleTreeNodeArray(vues.params.columnIds,[]);
                vues.orgIds= vues.params.organizationIds.split(',');
            })
        },
        saveReturn: function () {
            var vues = this;
            return new Promise((reslove, reject) => {

                vues.$refs.ruleForm.validate((valid) => {
                    if (valid) {
                        reslove(vues.params);
                    } else {
                        reslove(false);
                    }
                })
            })
        }
    },
    created: function () {
        var vues = this;
        var querys = this.$route.query;
        if (querys.id) {
            this.params.id = querys.id;
            this.editManagePostDTO();
        }
        this.getColumnTree();
        this.getOrgTree();
        this.getMenuTree();
        
    }
}
</script>

<style lang="scss" scoped>

</style>

<style lang="css">
.subpage.addrule_edit .el-input__inner {
    border-radius: 0px !important;
}

.subpage.addrule_edit .selects {
    width: 240px !important;
}

.subpage.addrule_edit .el-input {
    width: 240px !important;
}
</style>



// WEBPACK FOOTER //
// addRule.vue?3f256a7a